export const appStoreLinks = {
  iOS: 'http://itunes.apple.com/us/app/julius-baer-mobile/id1174398119',
  Android: 'https://play.google.com/store/apps/details?id=com.juliusbaer.jbmobile&hl=en&gl=US',
};
